// extracted by mini-css-extract-plugin
export var projects = "Projects-module--projects--2d53V";
export var projects__content = "Projects-module--projects__content--hfI7l";